const defaultState = {
    data: {
        type: 'basic',
        status: null,
        total_items: 0
    },
    filters: {
        page: 1,
        sizePerPage: 10,
        sortName: 'date',
        sortOrder: 'asc'
    },
};

const ifta = (state = defaultState, action) => {
    switch (action.type) {
        case 'GET_IFTA_REPORT_SUCCESS': {
            const reportType = action.payload.reportType || action.payload.data?.type || 'basic';
            return {
                ...state,
                data: {
                    ...state.data,
                    ...action.payload.data,
                    type: reportType
                }
            }
        }
        case 'SET_PAGINATION_FILTERS': {
            const filters = state.filters?.basic ? defaultState.filters : state.filters;
            return {
                ...state,
                filters: {
                    ...filters,
                    ...action.payload.filters
                }
            }
        }
        case 'SET_REPORT_STATUS': {
            const reportType = action.payload.reportType || state.data?.type || 'basic';
            return {
                ...state,
                data: {
                    ...state.data,
                    status: action.payload.status,
                    type: reportType
                }
            }
        }
        default:
            return state
    }
};

export default ifta;
